import useStore, { updateScreenWidth } from '../Store/Store';

import { Box, Button, Link, TextField, Typography } from '@mui/material';
import React from 'react';
import Logo from '../images/logo.png';
import SideImage from '../images/loginImage.svg';
import { forgotPassword } from '../utils/api';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';

const ForgotPassword = () => {
  const history = useNavigate();
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);
  const [state, setState] = React.useState({
    email: '',
    errorMessage: '',
    emailSent: false,
  });

  const updateDimensions = () => {
    updateScreenWidth(window.innerWidth);
  };
  React.useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  const resetPasswordHandler = useMutation(forgotPassword, {
    onSuccess: async ({ data }) => {
      setState((prev) => {
        return { ...prev, emailSent: true };
      });
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState({ errorMessage: error?.response?.data?.message || 'Something went wrong!' });
    },
  });

  const handleReset = async () => {
    if (!state.email) {
      return setState({
        errorMessage: 'Email is required fields',
      });
    }

    setState((prev) => {
      return { ...prev, errorMessage: '' };
    });

    resetPasswordHandler.mutate({ email: state.email });
  };

  React.useEffect(() => {
    if (!isEmpty(user)) {
      history('/main');
    }
  }, [user]);

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100vw',
        height: '100vh',
        backgroundColor: 'white',
      }}
    >
      {state.emailSent ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: width > 1050 ? '50%' : '100%',
            padding: '1rem',
          }}
        >
          <Box
            component="img"
            sx={{ width: '55px', height: '37.56px', marginBottom: '2rem' }}
            alt="Mask group"
            src={Logo}
          />
          <div style={{ paddingInline: '4rem', paddingBlock: '12rem' }}>
            <Typography variant="h4" gutterBottom mb={6}>
              Reset your password
            </Typography>

            <Typography variant="body1" mb={6}>
              You've got mail. Check your email for a password reset link.
            </Typography>

            <Button
              variant="contained"
              fullWidth
              sx={{
                borderRadius: '50px',
                marginBottom: '1rem',
                background: '#01796b',
              }}
              onClick={() => history('/login')}
            >
              Login
            </Button>

            <Typography component="h1" variant="subtitle1" style={{ color: 'red' }} textAlign="center" my={1}>
              {state.errorMessage}
            </Typography>

            <Typography variant="body2">
              Don’t have an account?
              <Link
                variant="body2"
                style={{
                  color: '#01796b',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  marginInline: '4px',
                }}
                href="/#/sign-up"
              >
                Sign Up
              </Link>
            </Typography>
          </div>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: width > 1050 ? '50%' : '100%',
            padding: '1rem',
          }}
        >
          <Box
            component="img"
            sx={{ width: '55px', height: '37.56px', marginBottom: '2rem' }}
            alt="Mask group"
            src={Logo}
          />
          <div style={{ paddingInline: '4rem', paddingBlock: '12rem' }}>
            <Typography variant="h4" gutterBottom mb={6}>
              Reset your password
            </Typography>

            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              sx={{ marginBottom: '1rem', borderRadius: '50px' }}
              InputProps={{
                style: { borderRadius: '50px' },
              }}
              onChange={(event) =>
                setState((prev) => {
                  return { ...prev, email: event.target.value };
                })
              }
            />

            <Button
              variant="contained"
              fullWidth
              sx={{
                borderRadius: '50px',
                marginBottom: '1rem',
                background: '#01796b',
              }}
              onClick={handleReset}
              disabled={resetPasswordHandler.isLoading}
            >
              {resetPasswordHandler.isLoading ? 'loading...' : 'Reset Password'}
            </Button>

            <Typography component="h1" variant="subtitle1" style={{ color: 'red' }} textAlign="center" my={1}>
              {state.errorMessage}
            </Typography>

            <Typography variant="body2">
              Back to
              <Link
                variant="body2"
                style={{
                  color: '#01796b',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  marginInline: '4px',
                }}
                href="/#/login"
              >
                Login
              </Link>
              or
              <Link
                variant="body2"
                style={{
                  color: '#01796b',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  marginInline: '4px',
                }}
                href="/#/sign-up"
              >
                Sign Up
              </Link>
            </Typography>
          </div>
        </Box>
      )}
      {width > 1050 && (
        <Box
          component="img"
          sx={{
            width: '50%',
            height: '97%',
            objectFit: 'cover',
            padding: '1rem',
            borderRadius: '30px',
          }}
          alt="Rectangle"
          src={SideImage}
        />
      )}
    </Box>
  );
};

export default ForgotPassword;
